export default __webpack_public_path__ + "static/qr-office-big-7d6c389caea6dd4d6d7b4ae94b096b38.webp";